exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date_block[data-v-1e6bcf10] {\n  margin-right: 3rem;\n}\n@media all and (max-width: 767px) {\n.date_block[data-v-1e6bcf10] {\n    margin-right: 0;\n}\n}", ""]);

// exports
